// extracted by mini-css-extract-plugin
export default {"error_message_wrapper":"style_error_message_wrapper__Hob-m","generate_pdf_text":"style_generate_pdf_text__fCkZW"};